import { css } from 'linaria';

export const productDescription = css`
  width: 877px;

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const collapseWrapper = css`
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 1.5s ease;
`;

export const collapseOpenWrapper = css`
  grid-template-rows: 1fr;
`;

export const collapseShowMoreBtnWrapper = css`
  position: relative;
  top: -40px;
  display: flex;
  align-items: flex-end;
  height: 136px;
  background: linear-gradient(360deg, #fff 0%, rgb(255 255 255 / 99%) 69%, rgb(255 255 255 / 0%) 100%);
`;

export const collapseOpenShowMoreBtnWrapper = css`
  background: inherit;
`;

export const collapseShowMoreBtn = css`
  width: 102px;
`;

export const productDescriptionText = css`
  min-height: 96px;

  @media (--only-tablet) {
    min-height: 120px;
  }

  @media (--only-mobile) {
    min-height: 137px;
  }

  p {
    padding: 0;
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--text-primary);

    &:last-child {
      margin-top: 16px;
    }
  }

  h3 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
  }
`;

export const collapseChevronIcon = css`
  transition: all 1s ease;
`;

export const collapseOpenChevronIcon = css`
  transform: rotate(-180deg);
`;
